module.exports = __webpack_public_path__ + "static/media/red-buggy-car.d72529f4.svg";